module.exports = __webpack_public_path__ + "img/symbol_5.9af7e9c5.png";